import React from "react";
import "./App.css";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
  AvFeedback,
  AvRadioGroup,
  AvRadio,
  AvCheckboxGroup,
  AvCheckbox
} from "availity-reactstrap-validation";
import axios from "axios";
import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-google';

export default class App extends React.Component {

  componentDidMount() {
    loadReCaptcha();
  }

  onLoadRecaptcha() {
      if (this.captchaDemo) {
          this.captchaDemo.reset();
      }
  }
  verifyCallback(recaptchaToken) {
    if (recaptchaToken) {
        this.setState({
          isVerified: true
        })
    }
    console.log(recaptchaToken);
  }

  constructor(props, context) {
    super(props, context);
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.state = {
      isVerified: false,
      onApiSuccess: false,
      onApiError: false,
      errorMessage: "could not send",
      showQuestion: false,
      isCaResident: null,
      values:{
        type:[],
        firstName:"",
        "lastName": "",
        "emailAddress": "",
        "isCaliforniaResident": null,
        "requestInfo": null,
        "relationship": "",
        "phoneNumber": "",
        "policyNumber": "",
        "minorBehalf": null,
      }
    };
  }

  showQuestion = (event, values) => {
      this.setState({
        showQuestion: true,
      });
  }

  hideQuestion = (event, values) => {
      this.setState({
        showQuestion: false,
      });
  }

  isCaResident = (event, values) => {
      this.setState({
        isCaResident: true,
      });
  }

  notCaResident = (event, values) => {
      this.setState({
        isCaResident: false,
      });
  }

  handleSubmit = (event, errors, values) => {
 event.preventDefault();
    this.setState({ errors, values });
    const postUrl = "https://ccpaservice.homesitep2.com/v1/ccpa/requests";
    // const postUrl = "https://g13lbn1zd4.execute-api.us-east-1.amazonaws.com/demo/v1/ccpa/requests";
    axios
      .post(process.env.url || postUrl, this.state.values)
      .then(response => {
        this.setState({ onApiSuccess: true });
      })
      .catch(error => {
        this.setState({
          onApiError: true,
          errorMessage: JSON.parse(JSON.stringify(error)).message
        });
      });
  };

  render() {
    const defaultValues = {
      type: 'DO_NOT_SELL',
    }
    return (
      <div className="app">
        <head>
          <link
            href="https://fonts.googleapis.com/css?family=Merriweather&display=swap"
            rel="stylesheet"
          ></link>
        </head>
        <body className="form-app">
          <h1>Personal Information Privacy Request</h1>
          {(() => {
            if (this.state.isVerified && this.state.onApiSuccess && this.state.isCaResident) {
              return <div class="success-msg">
                We received your personal information request and it will be
                processed soon. An insurance specialist will contact you if any
                additional information is needed to process your request. Thank
                you.
              </div>;
            } else if(this.state.isVerified && this.state.onApiSuccess &&!this.state.isCaResident){
              return <div class="success-msg ca">
                We received your personal information request. Please note, however, that we are only processing requests for residents of the state of California at this time. Thank you.
              </div>;
            } else {
              return <form name="ccpa-form">
                <p>
                  We would like to honor your request to the best of our ability,
                  in order to do so and to verify your identification, please
                  provide the following information.
                </p>
                <label for="type" class="input-label">
                  Request Type
                </label>
                <AvForm onSubmit={this.handleSubmit} model={defaultValues}>
                  <div class="form-box-row">
                    <AvCheckboxGroup
                      inline
                      class="input-checkbox"
                      name="type"
                      required
                      errorMessage="Please make at least one selection"
                      validate={{ min: { value: 1 } }}
                    >
                      <AvCheckbox
                        label="Do Not Sell My Personal Information or Sensitive Personal Information"
                        value="DO_NOT_SELL"
                      />
                      <AvCheckbox
                        label="Disclose My Personal Information & Your Third Party Data Sharing"
                        value="DISCLOSE"
                      />
                      <AvCheckbox
                        label="Delete My Personal Information"
                        value="DELETE"
                      />
                    </AvCheckboxGroup>
                  </div>
                  <div class="form-box form-box-name">
                    <div class="form-box form-box-firstName">
                      <AvGroup>
                        <label for="firstName">First Name</label>
                        <AvInput
                          placeholder="Enter First Name"
                          name="firstName"
                          id="firstName"
                          required
                        />
                        <AvFeedback>Please enter your name</AvFeedback>
                      </AvGroup>
                    </div>
                    <div class="form-box form-box-lastName">
                      <AvGroup>
                        <label for="lastName">Last Name</label>
                        <AvInput
                          placeholder="Enter Last Name"
                          name="lastName"
                          id="lastName"
                          required
                        />
                        <AvFeedback>Please enter your name</AvFeedback>
                      </AvGroup>
                    </div>
                  </div>
                  <div class="form-box">
                    <AvField
                      placeholder="Enter Email"
                      name="emailAddress"
                      label="Email Address"
                      type="email"
                      required
                    />
                  </div>
                  <div class="form-box-row residentOfCa">
                    <AvRadioGroup
                      name="isCaliforniaResident"
                      label="Applicable state of residence"
                      required
                      errorMessage="Please make a selection"
                    >
                      <AvRadio label="Yes" value={true} onClick={this.isCaResident}/>
                      <AvRadio label="No" value={false} onClick={this.notCaResident}/>
                    </AvRadioGroup>
                    {this.state.isCaResident===false &&(<div class="form-box invalid-feedbackCa">Please note that we are only processing requests for residents of the state of California at this time.</div>)}
                  </div>
                  <div class="form-box-row requestInfo">
                    <AvRadioGroup
                      name="requestInfo"
                      label="Is this request regarding your information?"
                      required
                      errorMessage="Please make a selection"
                    >
                      <AvRadio label="Yes" value={true} onClick={this.hideQuestion}/>
                      <AvRadio label="No" value={false} onClick={this.showQuestion}/>
                    </AvRadioGroup>
                  </div>
                  {this.state.showQuestion &&(
                    <div class="form-box-row minorBehalf">
                    <AvRadioGroup
                      name="minorBehalf"
                      label="Are you acting on behalf of a minor or an incapacitated
                individual?"
                      required
                      errorMessage="Please make a selection"
                    >
                      <AvRadio label="Yes" value={true} />
                      <AvRadio label="No" value={false} />
                    </AvRadioGroup>
                  </div>
                  )}
                  <div class="form-box">
                    <div class="select-wrapper">
                      <AvField
                        type="select"
                        name="relationship"
                        required
                        label="Relationship to Homesite?"
                        errorMessage="Please select your relationship to Homesite"
                      >
                        <option value="select">Select One</option>
                        <option value="POLICY_HOLDER">Policyholder</option>
                        <option value="FORMER_POLICY_HOLDER">
                          Former Policyholder
                        </option>
                        <option value="QUOTE_RECIPIENT">Quote Recipient</option>
                        <option value="CLAIMANT">Claimant</option>
                        <option value="EMPLOYEE">
                          Employee or Job Applicant
                        </option>
                        <option value="CONTRACTOR">Contractor</option>
                        <option value="VENDOR">Vendor</option>
                        <option value="LD_POLICY_HOLDER">
                          Life Direct Policyholder
                        </option>
                        <option value="LD_POLICY_OWNER">
                          Life Direct Policy Owner
                        </option>
                        <option value="LD_POLICY_PAYER">
                          Life Direct Policy Payer
                        </option>
                        <option value="LD_POLICY_BENEFICIARY">
                          Life Direct Beneficiary
                        </option>
                        <option value="OTHER">Other</option>
                      </AvField>
                    </div>
                  </div>
                  <div class="form-box">
                    <AvGroup>
                      <label for="phoneNumber">Phone (optional)</label>
                      <AvInput
                        placeholder="Enter Phone"
                        name="phoneNumber"
                        id="phone"
                      />
                    </AvGroup>
                    <p class="helpText">
                      In case we need to contact you about the request
                    </p>
                  </div>
                  <div class="form-box">
                    <AvGroup>
                      <label for="policyNumber">Policy Number (optional)</label>
                      <AvInput
                        placeholder="Customers, Enter Policy Number"
                        name="policyNumber"
                        id="policyNumber"
                      />
                    </AvGroup>
                  </div>
                  <div class="disclosure-box">
                    <hr></hr>
                    <span class="disclosure-footer">
                      The information that you are submitting as part of this
                      request will be used solely to facilitate our response and
                      will not be shared, sold, or disclosed. We will confirm
                      receipt of this information after you have submitted it for
                      our review. In order to complete some requests, further
                      correspondence may be required. For general information
                      about our Privacy practices, please see:
                      <br></br>
                      <a href="https://go.homesite.com/privacy-policy.html">
                        https://go.homesite.com/privacy-policy.html
                      </a>
                    </span>
                    <hr></hr>
                  </div>
                  <ReCaptcha
                        ref={(el) => {this.captchaDemo = el;}}
                        size="normal"
                        render="explicit"
                        sitekey="6LcRt8UUAAAAAG5_okuuS2gFxhE7ZMUWg0wCn4Ff"
                        onloadCallback={this.onLoadRecaptcha}
                        verifyCallback={this.verifyCallback}
                        required
                    />
                  <div class="form-submit">
                    <button id="btnSubmit">Submit</button>
                  </div>
                </AvForm>
                {this.state.onApiError &&(
                  <div class="error-field">
                    Something went wrong. Please confirm the above data fields
                    were completed properly and try submitting the form again. If
                    you continue to receive this error message, or need additional
                    assistance, you can contact us at 1-800-466-3748.
                  </div>
                )}
              </form>;
            }
          })()}
        </body>
      </div>
    );
  }
}
